import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full pt-16 pb-12 sm:pt-24 sm:pb-16 px-4" data-id="element-192">
      <div className="max-w-article mx-auto text-center" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-194">
          <span className="block text-[11px] font-bold uppercase tracking-widest text-sage mb-6" data-id="element-195">
            Advertorial · Rylte Research
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-medium leading-[1.1] text-forest mb-6" data-id="element-196">
            Why Your Gut Pain Keeps Coming Back — And What Nobody Has Told You.
          </h1>
          <p className="text-lg sm:text-xl text-ink/80 leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-197">
            And here's what finally stops it.
          </p>
          <div className="flex items-center justify-center space-x-2 text-sm text-ink/60 mb-12" data-id="element-198">
            <span data-id="element-199">By the Rylte Research Team</span>
            <span data-id="element-200">·</span>
            <span data-id="element-201">12 min read</span>
          </div>
        </motion.div>
      </div>

      <motion.div className="max-w-5xl mx-auto w-full rounded-2xl overflow-hidden shadow-sm" initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} data-id="element-202">
        <img src="https://cdn.magicpatterns.com/uploads/om2SxvsAAJyznhaB8mGW6K/hf_20260522_094957_f94a59d8-bc12-4872-8473-9f9c48d4768e.png" alt="Detailed anatomical close-up of intestinal tissue, glistening and segmented on a dark surface" className="w-full h-[400px] sm:h-[500px] md:h-[600px] object-cover object-center" data-id="element-203" />
      </motion.div>
    </section>;
}